import { useState } from 'react';

const STORAGE_KEY = 'referee-desk-theme';
const isTheme = value => value === 'light' || value === 'dark';

function initialTheme() {
    try {
        // Start with the club preference, but keep later desk changes local.
        for (const key of [STORAGE_KEY, 'theme']) {
            const saved = window.localStorage.getItem(key);
            if (isTheme(saved)) return saved;
        }
    } catch {
        // Storage can be unavailable in private or embedded browsers.
    }
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export default function useRefereeTheme() {
    const [theme, setTheme] = useState(initialTheme);
    const toggleTheme = () => {
        const next = theme === 'dark' ? 'light' : 'dark';
        setTheme(next);
        try {
            window.localStorage.setItem(STORAGE_KEY, next);
        } catch {
            // Switching still works for this visit when saving is blocked.
        }
    };
    return { theme, toggleTheme };
}
